import { Box, PressableBox, Row } from '@opendoor/bricks-next';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { LandingPageV2Props } from 'cms';
import landingPageV2EntryLookup from 'cms/entries/landingPageV2';
import RichTextRenderer from 'cms/renderer';
import { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import { getPaginationForData } from 'helpers/pagination';
import { useRouter } from 'next/router';
import LandingPageV2Layout, {
  getLandingpageV2ServerSideProps,
} from 'pages/shared/LandingPageV2Layout';

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => getLandingpageV2ServerSideProps(context);

const LandingPageWithContext = (props: LandingPageV2Props) => {
  const router = useRouter();
  const pageNumQuery = parseInt(router.query.page as string);

  const { previousPage, nextPage, currentPage, lastPage, showPagination } = getPaginationForData(
    props,
    pageNumQuery,
  );

  return (
    <LandingPageV2Layout {...props}>
      <Box display="block" height="$12" />
      <RichTextRenderer.Component
        body={props.fields.body}
        idToLoaderData={props.idToLoaderData}
        entryLookup={landingPageV2EntryLookup}
      />
      {showPagination && (
        <Row justifyContent="center" gap="$1" mt="$16">
          <PressableBox
            href={`?page=${previousPage}`}
            alignItems="center"
            justifyContent="center"
            width="$10"
            height="$10"
            backgroundColor="$backgroundSecondary"
            borderRadius="$4x"
            opacity={currentPage === 1 ? 0.5 : 1}
            disabled={currentPage === 1}
            cursor="pointer"
            analyticsName="topic-page-previous"
            aria-label="Go to previous page"
            pressStyle={{ transform: [{ scale: 0.8 }] }}
          >
            <IconArrowLeft size={16} />
          </PressableBox>
          <PressableBox
            href={`?page=${nextPage}`}
            alignItems="center"
            justifyContent="center"
            width="$10"
            height="$10"
            backgroundColor="$backgroundSecondary"
            borderRadius="$4x"
            opacity={currentPage === lastPage ? 0.5 : 1}
            disabled={currentPage === lastPage}
            cursor="pointer"
            analyticsName="topic-page-next"
            aria-label="Go to next page"
            pressStyle={{ transform: [{ scale: 0.8 }] }}
          >
            <IconArrowRight size={16} />
          </PressableBox>
        </Row>
      )}
      <Box display="block" height="$36" />
    </LandingPageV2Layout>
  );
};

export default LandingPageWithContext;
